import request from '@/utils/request'

// 用户热度统计
export function userOverview(params) {
	return request({
		url: '/discover/user/overview',
		method: 'get',
		params: params,
	})
}

// 浏览量、访客、总注册数
export function period(params) {
	return request({
		url: '/management/statistic/period',
		method: 'get',
		params: params
	})
}

// 当月接口访问次数排名
export function interfaceRank() {
	return request({
		url: '/management/statistic/interface/times',
		method: 'get',
	})
}

// 当月ip排名
export function ipRank() {
	return request({
		url: '/management/statistic/ip/location',
		method: 'get',
	})
}

// 各类资源占比
export function proportion() {
	return request({
		url: '/discover/proportion',
		method: 'get',
	})
}

// 用户奖励
export function awardOverview() {
	return request({
		url: '/management/reward/user/overview',
		method: 'get',
	})
}

// 获取全部用户数
export function getAllCount() {
	return request({
		url: '/user/get/all/count',
		method: 'get',
	})
}